<template>
  <div class="field parent-field">
      <label class="label has-text-left">{{label}}</label>
      <div class="field">
        <div class="control has-icons-left has-icons-right">
          <input :class="['input', classes]" @input="updateValue" @change="updateValue" type="text" v-model="value" />
          <span class="icon is-small is-left">
            <i :class="['fas', left_icon]" />
          </span>
          <span class="icon is-small is-right">
            <i v-if="touched"  :class="['fas', this.valid ? 'fa-check' : 'fa-times']" />
          </span>
        </div>
      </div>
    </div>
</template>


<script>
export default {
  data() {
    return {
      value: "",
      touched: false,
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.value);
      this.touched = true;
    },
  },
  props: {
    placeholder:{
      type: String,
    },
    classes: {
      type: Object,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
      default: "Enter"
    },
    left_icon: {
      type: String,
      default: null
    },
    right_icon_success: {
      type: String,
      default: null
    },
    right_icon_error: {
      type: String,
      default: null
    },
    valid: {
      type: Boolean,
      default: false,
    },
    pristine: {
      type: Boolean,
      default: false,
    }
  }
};
</script>


<style scoped>


.parent-field {
 margin: 0.5rem !important;
}

.label:first-child{
  margin-top: 0.5rem !important;
}
.label {
  margin-bottom: 0rem !important;
}

@media (max-width: 769px) {
  .parent-field {
    margin: 0rem;
  }
}

/* input::-webkit-input-placeholder {
    color:#C2C2C2;
}

input::-moz-placeholder {
    color:#C2C2C2;
}

input::-ms-placeholder {
    color:#C2C2C2;
}

input::placeholder {
    color:#C2C2C2;
} */

</style>